import { useContext, useEffect } from "react";
import PDDAuthContext from "../../store/pddStore/pdd-auth-context";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useHttpFetch from "../../hooks/useHttpFetch";
import LoadingOverLoadedPage from "../../Components/UI/LoadingOverLoadedPage/LoadingOverLoadedPage";
import { Helmet } from "react-helmet-async";

const IsLoggedInInPDD = () => {
  const { clientAuthInfo, setClientAuthInfo } = useContext(PDDAuthContext);
  const navigate = useNavigate();
  const { sendRequest } = useHttpFetch(false, "PDD");
  const location = useLocation();

  useEffect(() => {
    const getAuthOnLoad = async () => {
      const verifyReqOptions = {
        url: `CheckAccess`,
        noMiddleUrl: true,
      };

      const authRes = await sendRequest(verifyReqOptions);
      if (authRes?.resIsOk && authRes?.response?.userType?.toLowerCase()?.includes("personneldd")) {
        setClientAuthInfo((ps) => ({
          ...ps,
          isLoggedIn: true,
          cellphone: authRes?.response?.cellphone.replace("+98", "0"),
          nationalCode: authRes?.response?.nationalCode,
          firstName: authRes?.response?.firstName,
          lastName: authRes?.response?.lastName,
        }));
        navigate(
          `/personnel-document-digitization/${
            location?.pathname?.includes("333status") ? "333status" : "add"
          }/${authRes?.response?.firstName}/${authRes?.response?.lastName}/${
            authRes?.response?.nationalCode
          }/${authRes?.response?.cellphone.replace("+98", "0")}`
        );
      } else {
        navigate("/personnel-document-digitization/login");
      }

      setClientAuthInfo((ps) => ({
        ...ps,
        isLoading: false,
      }));
    };
    getAuthOnLoad();
  }, []);

  return (
    <>
      <Helmet>
        <meta name="description" content="PDD Information" />
        <meta property="og:title" content="Pergas Teb - PDD" />
        <meta property="og:description" content="PDD Information" />
        <meta name="twitter:title" content="Pergas Teb - PDD" />
        <meta name="twitter:description" content="PDD Information" />
        <title>Pergas Teb - PDD</title>
      </Helmet>
      {clientAuthInfo.isLoading ? <LoadingOverLoadedPage /> : <Outlet />}
    </>
  );
};

export default IsLoggedInInPDD;
